export var ObjectStoreCoverageReason;
(function (ObjectStoreCoverageReason) {
    ObjectStoreCoverageReason["OBJECT_STORE_COVERAGE_REASON_TIER"] = "TIER";
    ObjectStoreCoverageReason["OBJECT_STORE_COVERAGE_REASON_ACCESS_DENIED"] = "ACCESS_DENIED";
    ObjectStoreCoverageReason["OBJECT_STORE_COVERAGE_REASON_USER_FILTERED"] = "USER_FILTERED";
    ObjectStoreCoverageReason["OBJECT_STORE_COVERAGE_REASON_TRANSCODED"] = "TRANSCODED";
    ObjectStoreCoverageReason["OBJECT_STORE_COVERAGE_REASON_USER_DAILY_BUDGET_EXCEEDED"] = "USER_DAILY_BUDGET_EXCEEDED";
    ObjectStoreCoverageReason["OBJECT_STORE_COVERAGE_REASON_DELETED"] = "DELETED";
    ObjectStoreCoverageReason["OBJECT_STORE_COVERAGE_REASON_MODIFIED"] = "MODIFIED";
})(ObjectStoreCoverageReason || (ObjectStoreCoverageReason = {}));
